import { AppRouteRecordRaw } from '../types';
import { ORDER_ANALYTICS_EXCLUDED_PARTNERS } from '@/constants/order-analytics-excluded-partners';
import { ETranslationModule } from '@/i18n/translation';

const Body = () => import('@/components/body.vue');
const Default = () => import('@/pages/dashboard/default.vue');
const DashboardRequestStats = () =>
  import('@/pages/dashboard/api-requests-analytics/ApiRequestsAnalytics.vue');
const OrderStats = () =>
  import('@/pages/dashboard/orderInsightsAnalytics/OrderInsightsAnalytics.vue');
const OrderAnalyticsDashboard = () =>
  import('@/pages/insights-and-analytics/dashboard/OrderAnalyticsDashboard.vue');
const FileDownload = () => import('@/pages/dashboard/fileDownload/FileDownload.vue');

export const dashboardRoutes: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Body,
    meta: {
      breadcrumb: 'Home',
      // `fleet` is needed because Home now embeds the vehicle and driver panels, whose strings
      // live in that module (TASKFORCE-2748). The panels also load it themselves, so they work
      // wherever they are mounted — this just avoids a visible key flash on the Home route.
      i18nModules: [
        ETranslationModule.welcome,
        ETranslationModule.paymentMethod,
        ETranslationModule.fleet,
      ],
    },
    children: [
      {
        path: '',
        name: 'defaultRoot',
        component: Default,
        meta: {
          title: ' ryd Portal',
          breadcrumb: 'Welcome',
          headTitle: 'Welcome',
        },
      },
    ],
  },
  {
    path: '/dashboard',
    component: Body,
    meta: {
      breadcrumb: 'Home',
      // `fleet` is needed because Home now embeds the vehicle and driver panels, whose strings
      // live in that module (TASKFORCE-2748). The panels also load it themselves, so they work
      // wherever they are mounted — this just avoids a visible key flash on the Home route.
      i18nModules: [
        ETranslationModule.welcome,
        ETranslationModule.paymentMethod,
        ETranslationModule.fleet,
      ],
    },
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: Default,
        meta: {
          title: 'Welcome',
          breadcrumb: 'Welcome',
        },
      },
      {
        path: 'default',
        name: 'home',
        component: Default,
        meta: {
          title: ' Welcome | ryd Portal',
          breadcrumb: 'Welcome',
        },
      },
      {
        path: 'dashboard-request-stats',
        name: 'dashboardRequestStats',
        component: DashboardRequestStats,
        meta: {
          title: ' Dashboard Request Stats | ryd Portal',
          breadcrumb: 'API Requests Analytics',
        },
      },
      // The former general dashboard; its account metrics live in API Requests Analytics.
      { path: 'general-dashboard', redirect: '/dashboard/api-requests-analytics' },
      {
        path: 'api-requests-analytics',
        name: 'aPIRequestsAnalytics',
        component: DashboardRequestStats,
        meta: {
          title: ' API Requests Analytics | ryd Portal',
          breadcrumb: 'API Requests Analytics',
        },
      },
      {
        path: 'order-insights-analytics',
        name: 'orderInsightsAnalytics',
        component: OrderStats,
        meta: {
          title: ' Order Insights & Analytics | ryd Portal',
          breadcrumb: 'Order Insights & Analytics',
        },
      },
      {
        path: 'order-analytics-gas',
        name: 'orderAnalyticsGas',
        component: OrderAnalyticsDashboard,
        meta: {
          title: ' Order Analytics Gas | ryd Portal',
          breadcrumb: 'Order Analytics',
          // Mirrors the menu entry in constants/menu/sections/insights-analytics.ts
          // so the page is unreachable by direct link too, not just hidden.
          excludedPartners: ORDER_ANALYTICS_EXCLUDED_PARTNERS,
        },
      },
      // 'active-stations' moved: the export now runs against rp-integrations and the page is
      // registered next to its Station Management siblings, at
      // /insights-and-analytics/station-management/petrol-stations.
      {
        path: 'file-exchange',
        name: 'fileExchange',
        component: FileDownload,
        meta: {
          title: ' File Exchange | ryd Portal',
          breadcrumb: 'File Exchange',
        },
      },
    ],
  },
];
